export const COMPLETED = 'COMPLETED'
export const PENDING = 'PENDING'
export const TAKEN = 'TAKEN'
export const FAILED = 'FAILED'
export const REFUND = 'REFUND'
export const CANCELLED = 'CANCELLED'
export const CANCELED = 'CANCELED'

export const SUCCESS = 'SUCCESS'
